import "./App.css";
import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { warmUpGuestService } from "./services/appsScript";
import Head from "./views/head";
import FirstImage from "./views/firstImage"
import GreenHead from "./views/greenHead";
import GreenFoot from "./views/greenFoot";
import Text from "./views/text";
import Countdown from "./views/countdown";
import Schedule from "./views/schedule";
import SecondImage from "./views/secondImage";
import Locations from "./views/locations";
import Itinerary from "./views/Itinerary";
import ThirdImage from "./views/thirdImage";
import Outfit from "./views/outfit";
import Gift from "./views/gift";
import Confirm from "./views/confirm";
import Verse from "./views/verse";
import FourthImage from "./views/fourthImage";
import Form from "./views/form";
import Photos from "./views/photos";

function Home() {
  useEffect(() => {
    warmUpGuestService().catch(() => undefined);
  }, []);

  return (
    <>
      <header className="App-header"><Head /></header>
      <main id="main">
        <FirstImage />
        <div className="green-block">
          <GreenHead />
          <section className="green-section">
            <Text />
            <Countdown onComplete={() => alert('¡Llegó la fecha!')} />
            <Schedule />
          </section>
          <GreenFoot />
        </div>
        <SecondImage />
        <Locations />
        <Itinerary />
        <ThirdImage />
        <Outfit />
        <div className="green-block">
          <GreenHead />
          <section className="green-section">
            <Gift />
            <Confirm />
          </section>
          <GreenFoot />
        </div>

        <Verse />
        <FourthImage />
      </main>
      {/*<Booth />*/}
    </>
  );
};

function App() {
  return (
    <>
      {/*<Music />*/}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/confirmacion" element={<Form />} />
        <Route path="/fotos" element={<Photos />} />
      </Routes>
    </>
  );
}

export default App;
